/**
 * @module api-web:organizational-settlement
 * @description 组织结算
 */
import service from '@/service'

/**
 * 分销商
 */
export function getSubShipperList(params) {
  return service['api-web']({
    url: '/public/data/getSubShipper',
    method: 'get',
    params
  })
}

/**
 * 货主
 */
export function getShipperOrParentOrgList(params) {
  return service['api-web']({
    url: '/public/data/getShipperOrParentOrg',
    method: 'get',
    params
  })
}
/**
 * 货主-all
 */
export function getShipperOrParentOrgAllList(params) {
  return service['api-web']({
    url: '/public/data/getShipperList',
    method: 'get',
    params
  })
}

/**
 * 仓库下拉
 */
export function getWarehouseInfoByOrgList(data) {
  return service['api-web']({
    url: '/public/data/getFilterWarehouseInfo',
    method: 'post',
    data
  })
}

/**
 * 调出/调入仓库 查询调出/调入 货主
 */
export function getShipperByWarehouse(params) {
  return service['api-web']({
    url: '/public/data/getShipperByWarehouse',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * getWarehouseInfo4PickUp
 */
export function getWarehouseInfo4PickUp(params) {
  return service['api-web']({
    url: '/public/warehouse/getWarehouseInfo4PickUp',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
